module.exports = __webpack_public_path__ + "img/20180815_145537_012.b837f3f2.jpg";